import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=4c10eb6a&scoped=true&"
import script from "./TransferForm.vue?vue&type=script&lang=js&"
export * from "./TransferForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferForm.vue?vue&type=style&index=0&id=4c10eb6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10eb6a",
  null
  
)

export default component.exports